export function BtoMB (size) {
  return size / 1024 / 1024
}
